import type {
  Country,
  PersonalInfoProps,
  PersonalPaymentDetails,
} from '@openeducation/pp-rn-shared-types';

interface UsePersonalInfoProps {
  fullName?: string;
  email?: string;
  personalDetails?: PersonalPaymentDetails;
  countryISOCode?: Country['isoCode'];
}

export const usePersonalInfoProps = ({
  fullName = '',
  email = '',
  personalDetails,
  countryISOCode,
}: UsePersonalInfoProps) => {
  const personalInfoProps: PersonalInfoProps = {
    formData: {
      fullName,
      email,
      country: countryISOCode || '',
    },
    fields: {
      isFullNameEnabled: !!personalDetails?.fullName,
      isEmailEnabled: !!personalDetails?.email,
      isCountryEnabled: !!personalDetails?.country,
    },
  };

  return { personalInfoProps };
};
